import React from "react";
import { PlanLinkType } from "../models/plan-dependencies";
import styles from "./LinkTypeDiagram.module.scss";

/**
 * Схема типа связи: сверху предшественник (А), снизу последователь (Б), стрелка — от края А,
 * от которого идёт отсчёт, к краю Б, который ограничен. Как пиктограммы связей в MS Project.
 */
const SHAPES: { [type in PlanLinkType]: { a: [number, number]; b: [number, number]; path: string } } = {
    // Б начинается после конца А: от конца А к началу Б
    fs: { a: [3, 27], b: [33, 57], path: "M 27 12 V 24 H 33" },
    // Б начинается не раньше начала А: от начала А к началу Б
    ss: { a: [3, 39], b: [11, 51], path: "M 3 12 V 24 H 11" },
    // Б кончается не раньше конца А: от конца А в обход к концу Б
    ff: { a: [3, 39], b: [15, 49], path: "M 39 12 V 16 H 55 V 24 H 49" },
    // Б кончается не раньше начала А: от начала А в обход к концу Б
    sf: { a: [25, 57], b: [3, 31], path: "M 25 12 V 16 H 36 V 24 H 31" },
};

const TOP = 4;
const BOTTOM = 20;
const HEIGHT = 8;

export const LinkTypeDiagram: React.FC<{ type: PlanLinkType; className?: string }> = ({ type, className }) => {
    // у каждой схемы свой маркер: одинаковые id на странице путают браузер
    const marker = `link-type-arrow-${React.useId().replace(/:/g, "")}`;
    const shape = SHAPES[type] || SHAPES.fs;

    return (
        <svg
            className={`${styles.diagram} ${className || ""}`}
            width={60}
            height={32}
            viewBox="0 0 60 32"
            aria-hidden="true"
        >
            <rect className={styles.a} x={shape.a[0]} y={TOP} width={shape.a[1] - shape.a[0]} height={HEIGHT} rx={2} />
            <rect
                className={styles.b}
                x={shape.b[0]}
                y={BOTTOM}
                width={shape.b[1] - shape.b[0]}
                height={HEIGHT}
                rx={2}
            />
            <text className={styles.letter} x={shape.a[0] + 3} y={TOP + HEIGHT - 1.5}>
                А
            </text>
            <text className={styles.letter} x={shape.b[0] + 3} y={BOTTOM + HEIGHT - 1.5}>
                Б
            </text>
            {/* от края А, от которого отсчёт, к краю Б, который ограничен */}
            <path className={styles.arrow} d={shape.path} markerEnd={`url(#${marker})`} />
            <defs>
                <marker id={marker} viewBox="0 0 6 6" refX="5" refY="3" markerWidth="5" markerHeight="5" orient="auto">
                    <path d="M 0 0 L 6 3 L 0 6 z" className={styles.head} />
                </marker>
            </defs>
        </svg>
    );
};
